const AiCheck = [
  {
    path: '/ai-check',
    redirect: '/ai-check/home',
    children: [
      {
        path: '/home',
        name: 'AiCheckHome',
        component: () => import('@/views/ai-check/home'),
        meta: {
          layout: 'DefaultLayout',
          title: 'AI标书审查',
          inNavbar: true,
          pageType: 'public',
          routeGroup: '投标智能服务'
        }
      },
      {
        path: '/upload',
        name: 'AiCheckUpload',
        component: () => import('@/views/ai-check/upload'),
        meta: {
          layout: 'DefaultLayout',
          title: 'AI标书审查',
          inNavbar: false
        }
      },
      {
        path: '/result/:bizCode',
        name: 'AiCheckResult',
        component: () => import('@/views/ai-check/result'),
        meta: {
          layout: 'DefaultLayout',
          title: 'AI标书审查结果',
          inNavbar: false
        }
      },
      {
        path: '/buy',
        name: 'AiCheckBuy',
        component: () => import('@/views/ai-check/buy'),
        meta: {
          layout: 'DefaultLayout',
          title: 'AI标书审查流量包充值',
          inNavbar: false
        }
      }
      // {
      //   path: '/ai-bid',
      //   name: 'AiBid',
      //   meta: {
      //     title: '智能标书编写',
      //     inNavbar: true,
      //     pageType: 'public',
      //     routeGroup: '投标智能服务',
      //     externalLink: `${process.env.VUE_APP_AI_BID_URL}/ai-bid/bid-create/list`
      //   }
      // }
    ]
  }
]

export default AiCheck
